// extracted by mini-css-extract-plugin
export default {"InitialContainer":"InitialContainer_InitialContainer__YG0cm"};